<template>
  <div id="plans">
    <SubscriptionPlan name="Free" planId="FREE" :price="0" :subscription="subscription"
      @subscribe="unsubscribe()"
      :getButton="subscription.expiring ? 'Du har Free' : 'Skift til Free'"
      :features="[
        '<b>3</b> aktive ruter',
        '<b>35</b> stop per rute',
        'Importér fra Excel',
        'Kun offentlige ruter'
      ]" />

    <SubscriptionPlan name="Plus" planId="PLUS" :price="49" :subscription="subscription"
      @subscribe="subscribe('PLUS')"
      @reactivate="reactivateSubscription('PLUS')"
      @unsubscribe="unsubscribe()"
      :getButton="'Opgradér til Plus'"
      :features="[
        'Alt fra Free',
        '<b>10</b> aktive ruter',
        '<b>100</b> stop per rute',
        '<b>Live ruter</b>',
        'Private ruter'
      ]" />

      <Modal v-model="state.loading">
      <div class="text-c"> 
        <AppLoader />
        <h2>{{ $t('subscription.modal_redirect_title') }}</h2>
        <p>{{ $t('subscription.modal_redirect_desc') }}</p>
      </div>
    </Modal>

    <Modal v-model="state.activating">
      <div class="text-c"> 
        <AppLoader />
        <h2>{{ $t('subscription.modal_activate_title') }}</h2>
        <p>{{ $t('subscription.modal_activate_desc') }}</p>
      </div>
    </Modal>

    <Modal v-model="state.unsubscribing">
      <div class="text-c"> 
        <AppLoader />
        <h2>{{ $t('subscription.modal_cancel_title') }}</h2>
        <p>{{ $t('subscription.modal_cancel_desc') }}</p>
      </div>
    </Modal>

    <Modal v-model="state.proCongrats" closable> <ProCongrats /> </Modal>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { store } from '@/store'
import { subscribeToPlan, onPlanSubscriptionSuccess, cancelSubscription, continueSubscription, redirectTomanageSubscription } from '@/api/tripply/services/subscription.service'
import { toast } from '@/api/tools'
import { Plans } from '@/api/tripply/models'

import SubscriptionPlan from '@/components/subscription/SubscriptionPlan.vue'
import ProCongrats from '@/components/modals/ProCongrats.vue'

export default defineComponent({
  name: 'SubscriptionPlans',
  emits: ['select'],
  components: { SubscriptionPlan, ProCongrats },
  props: {},
  setup() {
    const user = store.user.get(state => state.user)
    const subscription = computed(() => store.user.state.subscription)
    const { t } = useI18n()
    const router = useRouter()
    
    const state = reactive({
      loading: false,
      activating: false,
      unsubscribing: false,
      proCongrats: false
    })

    onMounted(async () => {
      const query = router.currentRoute.value.query
      if (query.sessionId) {
        state.activating = true
        await onPlanSubscriptionSuccess(query.sessionId as string)
        state.proCongrats = true
        router.replace({ query: {} })
        toast({title: t('subscription.toast_activated'), type: 'success'})
      }
      if (query.canceled === null) {
        router.replace({ query: {} })
        toast({title: t('subscription.toast_error'), msg: t('subscription.toast_error_desc'), type: 'error'})
      }
    })
    
    async function subscribe(planId: keyof Plans) {
      state.loading = true
      await subscribeToPlan(planId)
    }

    async function reactivateSubscription() {
      state.activating = true
      await continueSubscription()
      toast({title: t('subscription.toast_reactivated'), type: 'success'})
      state.activating = false
    }


    async function unsubscribe() {
      state.unsubscribing = true
      await cancelSubscription()
      toast({title: t('subscription.toast_cancelled'), type: 'success'})
      state.unsubscribing = false
    }

    async function manage() {
      state.loading = true
      await redirectTomanageSubscription()
    }

    return { store, state, subscription, subscribe, unsubscribe, reactivateSubscription, manage, user }
  }
})
</script>

<style lang="scss">
#plans {
  display: flex;
}
@media only screen and (max-width: 640px) {
  #plans {
    flex-direction: column;

    .plan {
      max-width: unset !important;
      margin: 0 0 2rem 0 !important;
    }
  }
}
</style>